var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewFeaturesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3114 0.789493C15.3114 0.472996 15.1148 0.18709 14.8118 0.0631113C14.5088 -0.0608673 14.158 0.0010476 13.9207 0.220414L10.9997 2.91973C6.65073 6.9388 2.97593 11.5812 0.106138 16.6818C0.0385707 16.7965 0 16.929 0 17.0702C0 17.5062 0.367766 17.8597 0.821429 17.8597H7.90214V29.2105C7.90214 29.5231 8.09409 29.8063 8.39164 29.9327C8.68918 30.059 9.03626 30.0047 9.27674 29.7941L10.5837 28.6499C15.1585 24.6447 19.041 19.9651 22.0853 14.7869L22.8937 13.4118C23.0374 13.1674 23.0353 12.868 22.888 12.6256C22.7408 12.3831 22.4707 12.234 22.1786 12.234H15.3114V0.789493Z",
    fill: "#EB6424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFeaturesIcon);
export default __webpack_public_path__ + "static/media/new-features-icon.f0d122b015070f2abb38258e551aa6a6.svg";
export { ForwardRef as ReactComponent };